import { palette } from '../global/palette';
import { typography } from '../global/typography';
import type { ComponentOverride } from '../types';
import RemoveFilledModule from '@tdcerhverv/parrotfish/icons/RemoveFilled';
import { icon } from '../../utils/interop';

const RemoveFilledIcon = icon(RemoveFilledModule);
import SvgIcon from '@mui/material/SvgIcon';

export const MuiChip: ComponentOverride<'MuiChip'> = {
  MuiChip: {
    styleOverrides: {
      root: {
        padding: `3px 8px`,
        backgroundColor: palette.grey['200'],
      },
      outlined: {
        backgroundColor: palette.common['white'],
        borderColor: palette.grey[300],
        padding: 8,
        '&.MuiChip-clickable': {
          '&:hover': {
            borderColor: palette.grey[400],
            backgroundColor: palette.common['white'],
          },
          '&:active': {
            borderColor: palette.grey[600],
            backgroundColor: palette.common['white'],
            boxShadow: 'none',
          },
        },
      },
      clickable: {
        '&:active:not(.MuiChip-outlined)': {
          boxShadow: 'none',
          backgroundColor: palette.grey[400],
        },
        '&:hover:not(&:active):not(.MuiChip-outlined)': {
          backgroundColor: palette.grey[300],
        },
      },
      deletable: {
        '&:hover': {
          backgroundColor: palette.grey[300],
        },
        '&:active': {
          backgroundColor: palette.grey[400],
        },
      },
      sizeSmall: {
        padding: `2px 8px !important`,
      },
      label: {
        ...typography.body1,
        padding: `1px 6px`,
        display: 'flex',
        alignItems: 'center',
      },
      labelSmall: {
        ...typography.body2,
      },
      icon: {
        width: 16,
        height: 16,
        marginRight: 0,
        marginLeft: 4,
      },
      deleteIcon: {
        margin: 0,
        fontSize: 16,
        '&:hover': {
          color: palette.grey[600],
          height: 16,
        },
        '&:active': {
          color: palette.grey[800],
          height: 16,
        },
      },
      deleteIconSmall: {
        fontSize: 12,
      },
    },
    defaultProps: {
      deleteIcon: <SvgIcon component={RemoveFilledIcon} viewBox={'0 0 48 48'} />,
    },
  },
};
